import { formatCityString } from "@faire/retailer-visitor-shared/lib/formatCityString";
import { ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS } from "@faire/web--source/common/consts/ISO_TO_COUNTRY_NAME";
import { STATE_PROVINCE_SHORTHAND_TO_NAME } from "@faire/web--source/common/consts/STATE_PROVINCE_SHORTHAND_TO_NAME";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization/localize";
import startCase from "lodash/startCase";

type Input = {
  /**
   * Brand's based_in_city.
   */
  city?: string;
  /**
   * Brand's based_in_state.
   */
  state?: string;
  /**
   * Whether the output should be prefixed with "Based in" or not.
   */
  addBasedIn?: boolean;
  /**
   * Brand's based_in
   */
  country?: string;
};

export const getBrandLocationString = (
  input: Input,
  strictLocalize: StrictLocalizeFunction
): string | undefined => {
  const city = formatCityString(input.city);
  const state = startCase(
    // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
    STATE_PROVINCE_SHORTHAND_TO_NAME(strictLocalize)[input.state ?? ""] ??
      input.state
  );
  const country = input.country
    ? // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
      ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS(strictLocalize)[input.country]
    : undefined;

  if (city && state) {
    return input.addBasedIn
      ? strictLocalize(
          {
            defaultMessage: "Based in {CityAddress}, {StateAddress}",
            description: {
              text: "Where the brand is based",
            },
          },
          {
            CityAddress: city,
            StateAddress: state,
          }
        )
      : strictLocalize(
          {
            defaultMessage: "{CityAddress}, {StateAddress}",
            description: {
              text: "Brand's location (e.g. Los Angeles, California)",
            },
          },
          {
            CityAddress: city,
            StateAddress: state,
          }
        );
  }

  if (city || state) {
    return input.addBasedIn
      ? strictLocalize(
          {
            defaultMessage: "Based in {CityOrStateAddress}",
            description: {
              text: "Where the brand is based",
            },
          },
          {
            CityOrStateAddress: city || state,
          }
        )
      : city || state;
  }

  if (country) {
    return input.addBasedIn
      ? strictLocalize(
          {
            defaultMessage: "Based in {CountryAddress}",
            description: {
              text: "Where the brand is based",
            },
          },
          {
            CountryAddress: country,
          }
        )
      : strictLocalize(
          {
            defaultMessage: "{CountryAddress}",
            description: {
              text: "Brand's location (e.g. Australia)",
            },
          },
          {
            CountryAddress: country,
          }
        );
  }

  return undefined;
};
